<template>
	<div class="">
        <template v-if="create_payroll_batch === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Generate Payroll </h1>
                <button class="btn btn-primary float-right" @click="proceedToReview"> Next </button>
                <button class="btn btn-primary float-right mr-1" @click="cancelAutoGeneratePayroll"> Cancel </button>
                <div class="head-date float-right mr-2"> {{autoPayroll_date}} <i class="far fa-clock"></i> </div>
            </div>
            <hr class="border" />
            <div class="row normal-ib-space align-items-center mb-3">
                <div class="col-md-3"> <input id="customSearch" type="text" class="form-control search" placeholder="Search employee by name or Wallet Number" title="Search employee by name or Wallet Number" name="" /> </div>
                <div class="col-md-9">
                    <ul class="page-status text-right border-bottom-0 p-0">
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentUsers/+$route.params.id">
                                <span class="status-highlighter">1</span>Employees
                            </router-link>
                        </li>
                        <li class="page-status-list done">
                            <router-link :to="/autoPaymentTimeOff/+$route.params.id">
                                <span class="status-highlighter">2</span>Time Off
                            </router-link>
                        </li>
                        <li class="page-status-list active">
                            <span class="status-highlighter">3</span>
                            Earnings
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Review and Submit
                        </li>
                    </ul>
                </div>
            </div>
            <div class="autogenerate-content">
                <table id="dt-autogenerate-earning" class="table" style="width:100%">
                    <thead>
                        <tr>
                            <th>Employees</th>
                            <th>Additional Earnings</th>
                            <th>Reimbursements</th>
                            <th>Deductions</th>
                            <th>Time-off Deduction</th>
                            <th>Gross Pay</th>
                            <th class="text-center">Net Payment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(earning_user, index) in earning_users" v-bind:index="earning_user.id" v-bind:key="earning_user.id">
                            <td class="">
                                <div class="image-title">
                                    <div class="image-holder entity-detail-tooltip" data-toggle="tooltip">
                                        <img v-if="earning_user.user.avatar != null" :src="'/avatar/'+earning_user.user.avatar" alt="" />
                                        <img v-else src="/images/table-dummy-image.jpg" alt="" />
                                    </div>
                                    <div class="ag-employee-part">
                                        <span class="name"> {{earning_user.user.name}} </span>
                                        <span class="emp-status"> {{earning_user.user.status}} </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="overtime && overtime.length > 0">
                                    <span v-for="fr in overtime">
                                        <span v-if="fr.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, fr.amount,'Overtime')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{fr.amount}}, Overtime</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="bonus && bonus.length > 0">
                                    <span v-for="tr in bonus">
                                        <span v-if="tr.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, tr.amount,'Bonus')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{tr.amount}}, Bonus</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="commission && commission.length > 0">
                                    <span v-for="or in commission">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'Commission')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Commission</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="otherAdditionalEarning && otherAdditionalEarning.length > 0">
                                    <span v-for="or in otherAdditionalEarning">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'Other')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Others</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="conveyance && conveyance.length > 0">
                                    <span v-for="or in conveyance">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'Conveyance')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Conveyance</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="cola && cola.length > 0">
                                    <span v-for="or in cola">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'Cola')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Cola</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="utility && utility.length > 0">
                                    <span v-for="or in utility">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'Utility')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Utility</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="one_time && one_time.length > 0">
                                    <span v-for="or in one_time">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editAdditionalEarning(index, or.amount,'One Time')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, One Time</span>
                                        </span>
                                    </span>
                                </div>
                                <strong class="add-breakdown" @click="addAdditionalEarning(index)" > + Add </strong>
                            </td>
                            <td>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="fuelreimbursement && fuelreimbursement.length > 0">
                                    <span v-for="fr in fuelreimbursement">
                                        <span v-if="fr.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editReimbursementEarning(index, fr.amount,'Fuel')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{fr.amount}}, Fuel</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="travelreimbursement && travelreimbursement.length > 0">
                                    <span v-for="tr in travelreimbursement">
                                        <span v-if="tr.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editReimbursementEarning(index, tr.amount,'Treval')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{tr.amount}}, Travel</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="otherreimbursement && otherreimbursement.length > 0">
                                    <span v-for="or in otherreimbursement">
                                        <span v-if="or.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editReimbursementEarning(index, or.amount,'Other')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{or.amount}}, Others</span>
                                        </span>
                                    </span>
                                </div>
                                <!-- v-if="(fuelreimbursement && travelreimbursement && otherreimbursement) <= 0" -->
                                <strong class="add-breakdown" @click="addReimbursements(index)" > + Add </strong>
                            </td>
                            <td>
                                <!-- v-if="incomeTaxModule == 'ENABLED' && earning_users.net_salary != 0">-->
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="incometax && incometax.length > 0">
                                    <span v-for="it in incometax">
                                        <span v-if="it.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editDeductionEarning(index, it.amount,'Incometax')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{it.amount}}, Income Tax</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="eobi && eobi.length > 0">
                                    <span v-for="eb in eobi">
                                        <span v-if="eb.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editDeductionEarning(index, eb.amount,'Eobi')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{eb.amount}}, EOBI</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="providentfund && providentfund.length > 0"> 
                                    <span v-for="pf in providentfund">
                                        <span v-if="pf.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editDeductionEarning(index, pf.amount,'Providentfund')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{pf.amount}}, Provident Fund</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="otherdeduction && otherdeduction.length > 0">
                                    <span v-for="od in otherdeduction">
                                        <span v-if="od.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editDeductionEarning(index, od.amount,'Other')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{od.amount}}, Others</span>
                                        </span>
                                    </span>
                                </div>
                                <div :class="`add-salary-breakdown addSalaryBreakdownRecord_${(index)}`" v-if="advances && advances.length > 0">
                                    <span v-for="od in advances">
                                        <span v-if="od.payroll_sheet_id == earning_user.id">
                                            <strong class="add-breakdown edit" @click="editDeductionEarning(index, od.amount,'Advances')"> Edit </strong>
                                            <span class="data" addSalaryBreakdown="1">{{od.amount}}, Advances</span>
                                        </span>
                                    </span>
                                </div>
                                <!-- v-if="(incometax && eobi && providentfund && otherdeduction) <= 0" -->
                                <strong class="add-breakdown" @click="addDeductions(index)" > + Add </strong>
                            </td>
                            <td>{{formatAmount(earning_user.leave_absent_deduction)}}</td>
                            <td>{{formatAmount(earning_user.gross_salary)}}</td>
                            <td class="text-center">{{formatAmount(earning_user.net_salary)}}</td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <!-- Additional Earing Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="additionalEarnings" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Additional Earning </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="additionalEarning" placeholder="Rs. amount" type="number" min="0" class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="additionalEarningType" name="additionalEarningType" class="form-control selectpicker custom-select2">
                                    <option value="Overtime" :selected="additionalEarningType == 'Overtime'"> Overtime </option>
                                    <option value="Bonus" :selected="additionalEarningType == 'Bonus'"> Bonus </option>
                                    <option value="Commission" :selected="additionalEarningType == 'Commission'"> Commission </option>
                                    <option value="Other" :selected="additionalEarningType == 'Other'"> Other </option>
                                    <option value="Conveyance" :selected="additionalEarningType == 'Conveyance'"> Conveyance </option>
                                    <option value="Cola" :selected="additionalEarningType == 'Cola'"> Cola </option>
                                    <option value="Utility" :selected="additionalEarningType == 'Utility'"> Utility </option>
                                    <option value="One Time" :selected="additionalEarningType == 'One Time'"> One Time </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitAdditionalEarning(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Edit Additional Earing Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="editAdditionalEarnings" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Edit Additional Earning </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="additionalEarning" placeholder="Rs. amount" type="number" @keypress="isNumber($event)" min="0"  class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="additionalEarningType" name="additionalEarningType" class="form-control custom-select2 selectpicker-edit-additional">
                                    <option value="Overtime"> Overtime </option>
                                    <option value="Bonus"> Bonus </option>
                                    <option value="Commission"> Commission </option>
                                    <option value="Other"> Other </option>
                                    <option value="Cola"> Cola </option>
                                    <option value="Conveyance"> Conveyance </option>
                                    <option value="Utility"> Utility </option>
                                    <option value="One Time"> One Time </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitEditAdditionalEarning(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Reimbursement Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="reimbursements" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Reimbursement </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="reimbursent" placeholder="Rs. amount" type="number" min="0" id="reimbursement_amount" class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="reimbursentType" name="reimbursentType" class="form-control selectpicker custom-select2">
                                    <option value="Fuel"> Fuel </option>
                                    <option value="Treval"> Treval </option>
                                    <option value="Other"> Other </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitReimbursement(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edit Reimbursment Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="editReimbursementEarning" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Edit Reimbursement </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="reimbursent" placeholder="Rs. amount" type="number" @keypress="isNumber($event)" min="0" id="reimbursement_amount" class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="reimbursentType" name="reimbursentType" class="form-control selectpicker-edit-reimbursment custom-select2">
                                    <option value="Fuel"> Fuel </option>
                                    <option value="Treval"> Treval </option>
                                    <option value="Other"> Other </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitEditReimbursement(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Deductions Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="deductions" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Deductions </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="deductions" placeholder="Rs. amount" type="number" min="0" id="deduction_amount" class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="deductionsType" name="deductionsType" class="form-control selectpicker custom-select2">
                                    <option value="Incometax"> Income Tax </option>
                                    <option value="Eobi"> E.O.B.I </option>
                                    <option value="Providentfund"> Provident Fund </option>
                                    <option value="Other"> Other </option>
                                    <option value="Advances"> Advances </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitDeductions(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edit Deductions Modal -->
            <div class="modal payroll-auto-generate-breakdown-pop fade" id="editDeductions" tabindex="-1" role="dialog" aria-labelledby="additionalEarningsModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal" role="document">
                    <div class="modal-content">
                        <div class="modal-body p-4">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Edit Deductions </h2>
                            </div>
                            <div class="form-group">
                                <input v-model="deductions" placeholder="Rs. amount" type="number" min="0" id="deduction_amount" class="pop-field form-control" value="" name="" required />
                            </div>
                            <div class="form-group">
                                <select v-model="deductionsType" name="deductionsType" class="form-control selectpicker-edit-deduction custom-select2">
                                    <option value="Incometax"> Income Tax </option>
                                    <option value="Eobi"> E.O.B.I </option>
                                    <option value="Providentfund"> Provident Fund </option>
                                    <option value="Other"> Other </option>
                                    <option value="Advances"> Advances </option>
                                </select>
                            </div>
                            <div class="form-group m-0 text-right">
                                <button class="btn btn-primary closepop" data-dismiss="modal" aria-label="Close"> Close </button>
                                <button class="btn btn-primary submit submitButton" @click="submitEditDeductions(current_index)"> Submit </button>
                                <!-- <button class="btn btn-primary submit updateButton" style="display: none"> Update </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
        <template v-else-if="create_payroll_batch === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="create_payroll_batch === false">
            <notAllowed></notAllowed>
        </template>
	</div>
</template>

<script>
    var dtAutoGenerateEarningTable = null;
    export default {
        data() {
            return {
                create_payroll_batch:  null,
                earning_users: [],
                tax_calculations: [],
                autoPayroll: null,
                incomeTaxModule : null,
                providentFundModule : null,
                additionalEarning: 0,
                additionalEarningType: 'Overtime',
                reimbursent: 0,
                reimbursentType: 'Fuel',
                deductions: 0,
                deductionsType: 'Incometax',
                current_index : null,

                // form process data
                overtime: [],
                bonus: [],
                commission: [],
                otherAdditionalEarning: [],
                conveyance: [],
                cola: [],
                utility: [],
                one_time: [],
                fuelreimbursement: [],
                travelreimbursement: [],
                otherreimbursement: [],
                incometax: [],
                eobi: [],
                providentfund: [],
                otherdeduction: [],
                advances: [],
                net_salary: [],
                autoPayroll_date: '',
            }
        },
        methods: {
            handleEarnings(obj , property, i){
                let that = this;
                var final_net_amount = 0;
                final_net_amount = parseInt(final_net_amount) + parseInt(obj.amount);
                that.earning_users[i].net_salary += final_net_amount;
                if(obj.amount !== 0){
                    this[property].push(obj);
                }
            },

            handleDeductions(obj , property, i){
                let that = this;
                var final_net_amount = 0;
                final_net_amount = parseInt(final_net_amount) + parseInt(obj.amount);
                that.earning_users[i].net_salary -= final_net_amount;
                if(obj.amount !== 0){
                    this[property].push(obj);
                }
            },

            getAutoGenerateEarningData(){
                let that = this;
                this.$Progress.start();
                axios.get('/api/autoPayrollEarnings/'+this.$route.params.id)
                .then(res => {
                    this.autoPayroll    = res.data.autoGenPayroll;
                    this.earning_users  = res.data.records;
                    this.tax_calculations  = res.data.tax_calculation;
                    this.incomeTaxModule  = res.data.incomeTaxModule;
                    this.providentFundModule  = res.data.providentFundModule;
                   
                     $.each(res.data.tax_calculation,function(index,data){
                         if(data.income_tax>0 && res.data.incomeTaxModule=='ENABLED'){
                           var obj ={}
                           obj.payroll_sheet_id=data.payroll_sheet_id;
                           obj.amount=data.income_tax
                           that.incometax.push(obj);
                         }
                         if(data.provident_fund>0 && res.data.providentFundModule=='ENABLED'){
                            var obj ={}
                            obj.payroll_sheet_id=data.payroll_sheet_id;
                            obj.amount=data.provident_fund
                            that.providentfund.push(obj);
                         }
                        })
                    var user_obj = res.data.records;
                    
                    _.forEach(user_obj, function(e, i){
                        var payroll_sheet_id = e.id;         
                        //Additional Earning
                            if(e.addtional_earning){
                                if(e.addtional_earning.hasOwnProperty('overtime')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.overtime
                                    };
                                    that.handleEarnings(obj, 'overtime', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('bonus')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.bonus
                                    };
                                    that.handleEarnings(obj, 'bonus', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('commission')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.commission
                                    };
                                    that.handleEarnings(obj, 'commission', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('otherAdditionalEarning')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.otherAdditionalEarning
                                    };
                                    that.handleEarnings(obj, 'otherAdditionalEarning', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('conveyance')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.conveyance
                                    };
                                    that.handleEarnings(obj, 'conveyance', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('cola')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.cola
                                    };
                                    that.handleEarnings(obj, 'cola', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('utility')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.utility
                                    };
                                    that.handleEarnings(obj, 'utility', i);
                                }
                                if(e.addtional_earning.hasOwnProperty('one_time')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.addtional_earning.one_time
                                    };
                                    that.handleEarnings(obj, 'one_time', i);
                                }
                            }      
                            
                            //Reimbersment
                            if(e.reimbursement){
                                if(e.reimbursement.hasOwnProperty('fuelreimbursement')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.reimbursement.fuelreimbursement
                                    };
                                    that.handleEarnings(obj, 'fuelreimbursement', i);
                                }
                                if(e.reimbursement.hasOwnProperty('travelreimbursement')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.reimbursement.travelreimbursement
                                    };
                                    that.handleEarnings(obj, 'travelreimbursement', i);
                                }
                                if(e.reimbursement.hasOwnProperty('otherreimbursement')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.reimbursement.otherreimbursement
                                    };
                                    that.handleEarnings(obj, 'otherreimbursement', i);
                                }
                            }
                            
                            //Deduction
                            if(e.deductions){
                                if(e.deductions.hasOwnProperty('incometax')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.deductions.incometax
                                    };
                                    that.handleDeductions(obj, 'incometax', i);
                                    console.log(this.incometax);
                                }
                                if(e.deductions.hasOwnProperty('eobi')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.deductions.eobi
                                    };
                                    that.handleDeductions(obj, 'eobi', i);
                                }
                                if(e.deductions.hasOwnProperty('providentfund')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.deductions.providentfund
                                    };
                                    that.handleDeductions(obj, 'providentfund', i);
                                }
                                if(e.deductions.hasOwnProperty('otherdeduction')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.deductions.otherdeduction
                                    };
                                    that.handleDeductions(obj, 'otherdeduction', i);
                                }
                                if(e.deductions.hasOwnProperty('advances')){
                                    var obj = {
                                        'payroll_sheet_id': payroll_sheet_id,
                                        'amount' : e.deductions.advances
                                    };
                                    that.handleDeductions(obj, 'advances', i);
                                }
                            }
                            
                    });
                    
                    var date = moment(this.autoPayroll.from_date);
                    this.autoPayroll_date = date.format('MMMM, YYYY');
                    this.$Progress.finish();
                })
                .then(res => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.callDataTable();
                })
                // .catch(err => {
                //     // this.showAlertBox('error','Error to load data');
                //   this.showAlertBox('error', err);
                // });
            },

            addAdditionalEarning(index){
                this.current_index = index;
                $('#additionalEarnings').modal('show');
            },

            addReimbursements(index){
                this.current_index = index;
			    $('#reimbursements').modal('show');
            },

            addDeductions(index){
                this.current_index = index;
                $('#deductions').modal('show');
            },

            editAdditionalEarning: function(index,amount,type){
                this.current_index = index;
                this.additionalEarning = amount;
                this.additionalEarningType = type;
                
                $(".selectpicker-edit-additional").val(type);
                $(".selectpicker-edit-additional").selectpicker("refresh");
                $('#editAdditionalEarnings').modal('show');
            },
            editReimbursementEarning: function(index,amount,type){
                this.current_index = index;
                this.reimbursent = amount;
                this.reimbursentType = type;
                $(".selectpicker-edit-reimbursment").val(type);
                $(".selectpicker-edit-reimbursment").selectpicker("refresh");
                $('#editReimbursementEarning').modal('show');
            },
            editDeductionEarning: function(index,amount,type){
                this.current_index = index;
                this.deductions = amount;
                this.deductionsType = type;
                $(".selectpicker-edit-deduction").val(type);
                $(".selectpicker-edit-deduction").selectpicker("refresh");
                $('#editDeductions').modal('show');
            },
            submitAdditionalEarning(value){
                var final_net_amount = 0;
                final_net_amount = parseInt(final_net_amount) + parseInt(this.additionalEarning);
                this.earning_users[value].net_salary += final_net_amount;
                var payroll_sheet_id = this.earning_users[value].id;
                if(this.additionalEarningType == 'Overtime'){
                    if (this.overtime.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.overtime) {
                            if (this.overtime[i].payroll_sheet_id == payroll_sheet_id) {
                                this.overtime[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.overtime.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Bonus'){
                    if (this.bonus.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.bonus) {
                            if (this.bonus[i].payroll_sheet_id == payroll_sheet_id) {
                                this.bonus[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                       
                        this.bonus.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Commission'){
                   
                    if (this.commission.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.commission) {
                            if (this.commission[i].payroll_sheet_id == payroll_sheet_id) {
                                this.commission[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        
                        this.commission.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Other'){
                    if (this.otherAdditionalEarning.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherAdditionalEarning) {
                            if (this.otherAdditionalEarning[i].payroll_sheet_id == payroll_sheet_id) {
                                this.otherAdditionalEarning[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.otherAdditionalEarning.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Conveyance'){
                    if (this.conveyance.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.conveyance) {
                            if (this.conveyance[i].payroll_sheet_id == payroll_sheet_id) {
                                this.conveyance[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.conveyance.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Cola'){
                    if (this.cola.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.cola) {
                            if (this.cola[i].payroll_sheet_id == payroll_sheet_id) {
                                this.cola[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.cola.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Utility'){
                    if (this.utility.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.utility) {
                            if (this.utility[i].payroll_sheet_id == payroll_sheet_id) {
                                this.utility[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.utility.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'One Time'){
                    if (this.one_time.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.one_time) {
                            if (this.one_time[i].payroll_sheet_id == payroll_sheet_id) {
                                this.one_time[i].amount += parseInt(this.additionalEarning);
                                break;
                            }
                        }
                    }else{
                        this.one_time.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }
                this.additionalEarning = 0;
                this.additionalEarningType = 'Overtime';
                $('#additionalEarnings').modal('hide');
                $('#editAdditionalEarnings').modal('hide');
            },

            submitReimbursement(value){
                var final_net_amount = 0;
                final_net_amount = parseInt(final_net_amount) + parseInt(this.reimbursent);
                this.earning_users[value].net_salary += final_net_amount;
                var payroll_sheet_id = this.earning_users[value].id;
                if(this.reimbursentType == 'Fuel'){
                    if (this.fuelreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.fuelreimbursement) {
                            if (this.fuelreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                this.fuelreimbursement[i].amount += parseInt(this.reimbursent);
                                break;
                            }
                        }
                    }else{
                        this.fuelreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }else if(this.reimbursentType == 'Treval'){
                    if (this.travelreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.travelreimbursement) {
                            if (this.travelreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                this.travelreimbursement[i].amount += parseInt(this.reimbursent);
                                break;
                            }
                        }
                    }else{
                        this.travelreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }else if(this.reimbursentType == 'Other'){
                    if (this.otherreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherreimbursement) {
                            if (this.otherreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                this.otherreimbursement[i].amount += parseInt(this.reimbursent);
                                break;
                            }
                        }
                    }else{
                        this.otherreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }
                this.reimbursent = 0;
                this.reimbursentType = 'Fuel';
                $('#reimbursements').modal('hide');
            },

            submitDeductions(value){
                var final_net_amount = 0;
                final_net_amount = parseInt(final_net_amount) + parseInt(this.deductions);
                this.earning_users[value].net_salary -= final_net_amount;
                if(this.earning_users[value].net_salary <= '0')
                {
                    this.earning_users[value].net_salary = 0;
                }
                var payroll_sheet_id = this.earning_users[value].id;
                if(this.deductionsType == 'Incometax'){
                    if (this.incometax.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.incometax) {
                            if (this.incometax[i].payroll_sheet_id == payroll_sheet_id) {
                                this.incometax[i].amount += parseInt(this.deductions);
                                break;
                            }
                        }
                    }else{
                        this.incometax.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                    console.log(this.incometax)
                }else if(this.deductionsType == 'Eobi'){
                    if (this.eobi.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.eobi) {
                            if (this.eobi[i].payroll_sheet_id == payroll_sheet_id) {
                                this.eobi[i].amount += parseInt(this.deductions);
                                break;
                            }
                        }
                    }else{
                        this.eobi.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Providentfund'){
                    if (this.providentfund.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.providentfund) {
                            if (this.providentfund[i].payroll_sheet_id == payroll_sheet_id) {
                                this.providentfund[i].amount += parseInt(this.deductions);
                                break;
                            }
                        }
                    }else{
                        this.providentfund.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Other'){
                    if (this.otherdeduction.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherdeduction) {
                            if (this.otherdeduction[i].payroll_sheet_id == payroll_sheet_id) {
                                this.otherdeduction[i].amount += parseInt(this.deductions);
                                break;
                            }
                        }
                    }else{
                        this.otherdeduction.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Advances'){
                    if (this.advances.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.advances) {
                            if (this.advances[i].payroll_sheet_id == payroll_sheet_id) {
                                this.advances[i].amount += parseInt(this.deductions);
                                break;
                            }
                        }
                    }else{
                        this.advances.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }
                this.deductions = 0;
                this.deductionsType = 'Incometax';
                $('#deductions').modal('hide');
            },

            submitEditAdditionalEarning(value){
                var payroll_sheet_id = this.earning_users[value].id;
                //Handle Edit Additional Changes
                if(this.additionalEarningType == 'Overtime'){
                    if (this.overtime.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.overtime) {
                            if (this.overtime[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.overtime[i].amount){
                                    var final_net_amount = this.additionalEarning - this.overtime[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.overtime[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.overtime[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.overtime[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.overtime.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }
                else if(this.additionalEarningType == 'Bonus'){
                    if (this.bonus.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.bonus) {
                            if (this.bonus[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.bonus[i].amount){
                                    var final_net_amount = this.additionalEarning - this.bonus[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.bonus[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.bonus[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.bonus[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.bonus.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Commission'){
                    if (this.commission.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.commission) {
                            if (this.commission[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.commission[i].amount){
                                    var final_net_amount = this.additionalEarning - this.commission[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.commission[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.commission[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.commission[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.commission.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Other'){
                    if (this.otherAdditionalEarning.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherAdditionalEarning) {
                            if (this.otherAdditionalEarning[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.otherAdditionalEarning[i].amount){
                                    var final_net_amount = this.additionalEarning - this.otherAdditionalEarning[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.otherAdditionalEarning[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.otherAdditionalEarning[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.otherAdditionalEarning[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.otherAdditionalEarning.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Conveyance'){
                    if (this.conveyance.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.conveyance) {
                            if (this.conveyance[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.conveyance[i].amount){
                                    var final_net_amount = this.additionalEarning - this.conveyance[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.conveyance[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.conveyance[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.conveyance[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.conveyance.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Cola'){
                    if (this.cola.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.cola) {
                            if (this.cola[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.cola[i].amount){
                                    var final_net_amount = this.additionalEarning - this.cola[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.cola[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.cola[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.cola[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.cola.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'Utility'){
                    if (this.utility.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.utility) {
                            if (this.utility[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.utility[i].amount){
                                    var final_net_amount = this.additionalEarning - this.utility[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.utility[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.utility[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.utility[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.utility.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }else if(this.additionalEarningType == 'One Time'){
                    if (this.one_time.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.one_time) {
                            if (this.one_time[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.additionalEarning >= this.one_time[i].amount){
                                    var final_net_amount = this.additionalEarning - this.one_time[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.one_time[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.one_time[i].amount - this.additionalEarning;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.one_time[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.one_time.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.additionalEarning)});
                    }
                }
                // Handle Edit Deduction Case
                $('#editAdditionalEarnings').modal('hide');
            },

            submitEditReimbursement(value){
                var payroll_sheet_id = this.earning_users[value].id;
                //Handle Edit Additional Changes
                if(this.reimbursentType == 'Fuel'){
                    if (this.fuelreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.fuelreimbursement) {
                            if (this.fuelreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.reimbursent >= this.fuelreimbursement[i].amount){
                                    var final_net_amount = this.reimbursent - this.fuelreimbursement[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.fuelreimbursement[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.fuelreimbursement[i].amount - this.reimbursent;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.fuelreimbursement[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.fuelreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }else if(this.reimbursentType == 'Treval'){
                    if (this.travelreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.travelreimbursement) {
                            if (this.travelreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.reimbursent >= this.travelreimbursement[i].amount){
                                    var final_net_amount = this.reimbursent - this.travelreimbursement[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.travelreimbursement[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.travelreimbursement[i].amount - this.reimbursent;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.travelreimbursement[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.travelreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }else if(this.reimbursentType == 'Other'){
                    if (this.otherreimbursement.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherreimbursement) {
                            if (this.otherreimbursement[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.reimbursent >= this.otherreimbursement[i].amount){
                                    var final_net_amount = this.reimbursent - this.otherreimbursement[i].amount;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.otherreimbursement[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.otherreimbursement[i].amount - this.reimbursent;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.otherreimbursement[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.otherreimbursement.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.reimbursent)});
                    }
                }
                $('#editReimbursementEarning').modal('hide');
            },
            submitEditDeductions(value){
                var payroll_sheet_id = this.earning_users[value].id;
                if(this.deductionsType == 'Incometax'){
                    if (this.incometax.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.incometax) {
                            if (this.incometax[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.deductions >= this.incometax[i].amount){
                                    var final_net_amount = this.deductions - this.incometax[i].amount;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.incometax[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.incometax[i].amount - this.deductions;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.incometax[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                              console.log(this.incometax);
                    }else{
                        this.incometax.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Eobi'){
                    if (this.eobi.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.eobi) {
                            if (this.eobi[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.deductions >= this.eobi[i].amount){
                                    var final_net_amount = this.deductions - this.eobi[i].amount;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.eobi[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.eobi[i].amount - this.deductions;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.eobi[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.eobi.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Providentfund'){
                    if (this.providentfund.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.providentfund) {
                            if (this.providentfund[i].payroll_sheet_id == payroll_sheet_id) {
                                if (this.providentfund[i].payroll_sheet_id == payroll_sheet_id) {
                                    if(this.deductions >= this.providentfund[i].amount){
                                        var final_net_amount = this.deductions - this.providentfund[i].amount;
                                        this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                        this.providentfund[i].amount += parseInt(final_net_amount);
                                    }else{
                                        var final_net_amount = this.providentfund[i].amount - this.deductions;
                                        this.earning_users[value].net_salary += parseInt(final_net_amount);
                                        this.providentfund[i].amount -= parseInt(final_net_amount);
                                    }
                                    break;
                                }
                            }
                        }
                    }else{
                        this.providentfund.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Other'){
                    if (this.otherdeduction.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.otherdeduction) {
                            if (this.otherdeduction[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.deductions >= this.otherdeduction[i].amount){
                                        var final_net_amount = this.deductions - this.otherdeduction[i].amount;
                                        this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                        this.otherdeduction[i].amount += parseInt(final_net_amount);
                                    }else{
                                        var final_net_amount = this.otherdeduction[i].amount - this.deductions;
                                        this.earning_users[value].net_salary += parseInt(final_net_amount);
                                        this.otherdeduction[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.otherdeduction.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }else if(this.deductionsType == 'Advances'){
                    if (this.advances.some(e => e.payroll_sheet_id === payroll_sheet_id)) {
                        for (var i in this.advances) {
                            if (this.advances[i].payroll_sheet_id == payroll_sheet_id) {
                                if(this.deductions >= this.advances[i].amount){
                                    var final_net_amount = this.deductions - this.advances[i].amount;
                                    this.earning_users[value].net_salary -= parseInt(final_net_amount);
                                    this.advances[i].amount += parseInt(final_net_amount);
                                }else{
                                    var final_net_amount = this.advances[i].amount - this.deductions;
                                    this.earning_users[value].net_salary += parseInt(final_net_amount);
                                    this.advances[i].amount -= parseInt(final_net_amount);
                                }
                                break;
                            }
                        }
                    }else{
                        this.advances.push({'payroll_sheet_id': payroll_sheet_id, 'amount': parseInt(this.deductions)});
                    }
                }
                $('#editDeductions').modal('hide');
            },

            callDataTable(){
                var that = this;
                dtAutoGenerateEarningTable = $('#dt-autogenerate-earning').DataTable({
                    "sDom": '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    "searching":true,
                    columnDefs: [ {
                        orderable: false,
                    }],
                    order: [[ 0, "desc" ]],
                });
                $(document).ready(function() {
                    $('#customSearch').on( 'keyup', function () {
                        dtAutoGenerateEarningTable.search( this.value ).draw();
                });

                    var vendorDetailTooltip = '<div class="autogenerate-detail-tooltip">' +
                                                    '<h2> Jawad Amjad </h2>'+
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Account Type </span>' +
                                                        '<span class="tooltip-col">  SIMSIM </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> SimSim/Account No. </span>' +
                                                        '<span class="tooltip-col"> 923784613136 </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Employment Status </span>' +
                                                        '<span class="tooltip-col"> PERMANENT </span>' +
                                                    '</p>' +
                                                    '<p class="custom-tooltip-content">' +
                                                        '<span class="tooltip-col tooltip-title"> Department </span>' +
                                                        '<span class="tooltip-col"> Development </span>' +
                                                    '</p>' +
                                                '</div>';
                    $(".entity-detail-tooltip").tooltip({
                        title: vendorDetailTooltip,
                        html: true,
                        placement: 'top',
                        offset: '80',
                        template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'

                    });
                });
            },
            cancelAutoGeneratePayroll(){
              swal.fire({
                    title: 'Are you sure?',
                    // text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    var id = this.autoPayroll.id;
                    if (result.value) {
                        axios.post('/api/cancelAutoGeneratePayroll', {id})
                            .then(res => {
                                if(res.data.status == '200'){
                                    this.showToastBox('success',res.data.msg);
                                    this.$router.push('/employeePayments');
                                }else{
                                    this.showToastBox('error',res.data.msg);
                                }
                            })
                            .catch(err => {
                                this.showAlertBox('error','System Not Responding Please Try Again');
                            });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.showAlertBox('error','Cancelled','Your decision has been cancelled');
                    }
                });
            },
            proceedToReview(){
                this.$Progress.start();
                let that = this;
                this.earning_users.forEach(function(earning_user){
                    that.net_salary.push({id:earning_user.id,net_salary:earning_user.net_salary});
                });
                var formData = {
                    payroll_id              : this.autoPayroll.id,
                    overtime                : this.overtime,
                    commission              : this.commission,
                    bonus                   : this.bonus,
                    otherAdditionalEarning  : this.otherAdditionalEarning,
                    conveyance              : this.conveyance,
                    cola                    : this.cola,
                    utility                 : this.utility,
                    one_time                : this.one_time,
                    fuelreimbursement       : this.fuelreimbursement,
                    travelreimbursement     : this.travelreimbursement,
                    otherreimbursement      : this.otherreimbursement,
                    incometax               : this.incometax,
                    eobi                    : this.eobi,
                    providentfund           : this.providentfund,
                    otherdeduction          : this.otherdeduction,
                    advances                : this.advances,
                    net_salary              : this.net_salary,
                };
                axios.post('/api/processAutoEarningPayroll', formData)
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success',res.data.msg);
                        this.$router.push('/autoPaymentReview/'+res.data.batch_id);
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            incomeTaxDeduction(deduction){
            }
        },
        created() {
            //
        },
        mounted() {
            this.$Progress.start();
			this.can('create_payroll_batch').then(result => {
                this.create_payroll_batch = result.create_payroll_batch;
            }).then(result => {
                if(this.create_payroll_batch == true){
					this.getAutoGenerateEarningData();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            }).then(result => {
                 $('.selectpicker').selectpicker();
            });

        },
    }
</script>
